import { Elements } from "@/components/elements/Elements";
import { Note, Notebook } from "@/components/elements/Notes/types";
import { WeatherParameters } from "@/components/elements/Weather/types";
import { User } from "@/lib/types";
import { TodoType } from "@/services/todolist";
import { DBSchema, IDBPDatabase } from "idb";

export interface Schema extends DBSchema {
  appState:
    | {
        key: `elements.visibility.${string}`;
        value: boolean | null;
      }
    | {
        key: "activeProfileId";
        value: string | null;
      }
    | {
        key: "auth.dismissed";
        value: boolean;
      }
    | {
        key: "auth.user";
        value: User | null;
      }
    | {
        key: "auth.accessToken";
        value: string | null;
      }
    | {
        key: "ai.provider";
        value: string | null;
      };
  elements: {
    key: string;
    value: {
      id: string;
      name: keyof typeof Elements;
      parentId: string | null;
      childrenIds: string[];
      profileId: string | null;
      config: string;
    };
    indexes: {
      id: string;
      profileId: string;
    };
  };
  stickyNotes: {
    key: string;
    value: {
      elementId: string;
      content: string;
    };
  };
  weatherConfig: {
    key: string;
    value: {
      elementId: string;
    } & WeatherParameters;
  };
  todos: {
    key: string;
    value: TodoType;
    indexes: {
      id: string;
    };
  };
  notes: {
    key: string;
    value: Note;
    indexes: {
      id: string;
      notebookId: string;
    };
  };
  notebooks: {
    key: string;
    value: Notebook;
    indexes: {
      id: string;
    };
  };
}

export const migration = async (db: IDBPDatabase<Schema>) => {
  const notesStore = db.createObjectStore("notes", {
    keyPath: "id",
  });
  notesStore.createIndex("id", "id");
  notesStore.createIndex("notebookId", "notebookId", {
    multiEntry: true,
  });

  const notebooksStore = db.createObjectStore("notebooks", {
    keyPath: "id",
  });
  notebooksStore.createIndex("id", "id");
};
